/**
 * Converts a phone number string (e.g. +13522437099 or 3522437099) to
 * the standard US display format XXX-XXX-XXXX.
 * Returns the original string unchanged if it cannot be normalized.
 */
export function formatPhoneNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length !== 10) return phone;
  return `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}`;
}
